export default "__VITE_PUBLIC_ASSET__69f1f2a1__"